import {
  Button,
  Card,
  Form,
  Input,
  List,
  Modal,
  Typography,
  Upload,
  message,
  Tooltip,
  Popconfirm,
} from "antd";
import {
  LoadingOutlined,
  PlusOutlined,
  DeleteOutlined,
  EditOutlined,
} from "@ant-design/icons";
import React, { useState } from "react";

import ImgCrop from "antd-img-crop";
import {
  addSessionCategory,
  deleteSessionCategory,
} from "../../../store/actions/onlineClass";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";

const { Text } = Typography;

const SessionCategoriesList = (props) => {
  const {
    data,
    onCategorySelect,
    selectedCategoryId,
    addSessionCategory,
    deleteCategory,
    classId,
    preview = true,
  } = props;
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const onCreate = async (data) => {
    setLoading(true);
    await addSessionCategory({
      description: data.description,
      name: data.name,
      classId: classId,
      file: data.file,
    });
    setLoading(false);
    setShowModal(false);
  };

  const deleteCategoryHandle = async (classId, categoryId) => {
    setDeleting(true);
    await deleteCategory(classId, categoryId);
    setDeleting(false);
  };

  return (
    <Card
      title={<Text strong>Categories</Text>}
      extra={
        preview ? null : (
          <Button type="primary" onClick={() => setShowModal(true)}>
            Add new category
          </Button>
        )
      }
      style={{ margin: "1rem 1rem 0 1rem" }}
    >
      <List
        rowKey={"id"}
        grid={{
          gutter: 2,
          column: 8,
        }}
        dataSource={data}
        renderItem={(item) => (
          <List.Item>
            <Card
              actions={[
                <NavLink to={`/classes/${classId}/categories/${item.id}`}>
                  <Tooltip title="Edit Category">
                    <Button className="session-action" type="text" key="edit">
                      <EditOutlined />
                    </Button>
                  </Tooltip>
                </NavLink>,

                <Popconfirm
                  title="Are you sure you want to delete this session category?"
                  onConfirm={() => deleteCategoryHandle(classId, item.id)}
                  okText="Yes"
                  cancelText="No"
                  disabled={deleting}
                  key="delete"
                >
                  <Tooltip title="Delete Category">
                    <Button className="session-action" type="text" key="delete">
                      <DeleteOutlined />
                    </Button>
                  </Tooltip>
                </Popconfirm>,
              ]}
              onClick={() =>
                item.id === selectedCategoryId
                  ? onCategorySelect(null, null)
                  : onCategorySelect(item.id, item.name)
              }
              bodyStyle={{
                textAlign: "center",
                padding: "10px",
                backgroundColor:
                  item.id === selectedCategoryId ? "#1890ff" : "white",
              }}
              cover={<img alt="example" src={item.coverUrl} />}
              hoverable
            >
              <Text
                style={{
                  color: item.id === selectedCategoryId ? "white" : "",
                }}
                strong={item.id === selectedCategoryId}
              >
                {item.name}
              </Text>
            </Card>
          </List.Item>
        )}
      />
      <CategoryAdd
        visible={showModal}
        onCreate={onCreate}
        onCancel={() => setShowModal(false)}
        loading={loading}
      />
    </Card>
  );
};

const CategoryAdd = ({ visible, onCreate, onCancel, loading }) => {
  const [form] = Form.useForm();
  const [imageUrl, setImageUrl] = useState(null);
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);

  return (
    <Modal
      visible={visible}
      title="Add new category"
      okText="Add"
      cancelText="Cancel"
      onCancel={onCancel}
      okButtonProps={{ loading: loading }}
      cancelButtonProps={{ disabled: loading }}
      onOk={() => {
        if (!imageUrl) return message.warn("select a cover image");
        form
          .validateFields()
          .then((values) => {
            form.resetFields();
            onCreate({ ...values, file });
          })
          .catch((info) => {
            // console.log("Validate Failed:", info);
          });
      }}
    >
      <Form
        form={form}
        layout="vertical"
        name="form_in_modal"
        initialValues={{
          modifier: "public",
        }}
      >
        <ImgCrop rotate>
          <Upload
            accept={".jpg"}
            listType="picture-card"
            className="cover-edit"
            disabled={uploading}
            showUploadList={false}
            beforeUpload={(e) => {
              setFile(e);
              var urlCreator = window.URL || window.webkitURL;
              setImageUrl(urlCreator.createObjectURL(e));
              return false;
            }}
          >
            {imageUrl ? (
              <img src={imageUrl} alt="cover" style={{ width: "100%" }} />
            ) : (
              <div>
                {uploading ? <LoadingOutlined /> : <PlusOutlined />}
                <div className="ant-upload-text">Upload</div>
              </div>
            )}
          </Upload>
        </ImgCrop>
        <Form.Item
          name="name"
          label="Name"
          rules={[
            {
              required: true,
              message: "Name cannot be empty",
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="description"
          label="Description"
          rules={[
            {
              required: true,
              message: "Description cannot be empty",
            },
          ]}
        >
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
};

const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    deleteCategory: (classUid, categoryUid) =>
      dispatch(deleteSessionCategory(classUid, categoryUid)),
    addSessionCategory: (data) => dispatch(addSessionCategory(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SessionCategoriesList);